import Cookies from "js-cookie";
import RingCentralWebPhone from "ringcentral-web-phone";

import { safeJsonParse } from "../components/global/JsonHelper";

export default class RingCentralService {
  RING_CENTRAL_AUTH;

  CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
  REDIRECT_URI = `${process.env.REACT_APP_URL || "https://api.healthnsync.com"}/callback`;
  AUTH_URL = "https://platform.ringcentral.com/restapi/oauth/authorize";
  TOKEN_URL = "https://platform.ringcentral.com/restapi/oauth/token";

  generateRandomString(length) {
    return btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(length))))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  }

  async sha256Base64Url(plain) {
    const encoder = new TextEncoder();
    const data = encoder.encode(plain);
    const hash = await crypto.subtle.digest("SHA-256", data);
    const base64 = btoa(String.fromCharCode(...new Uint8Array(hash)))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
    return base64;
  }

  generateCodeVerifier(length = 128) {
    const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
    let result = "";
    const values = new Uint8Array(length);
    crypto.getRandomValues(values);
    for (let i = 0; i < values.length; i++) {
      result += charset[values[i] % charset.length];
    }
    return result;
  }

  async startRingCentralOAuth(navigate) {
    const rcAuth = await this.getCookie();
    if (rcAuth) {
      navigate(
        "/dashboard?offset=0&limit=100&overall_status__in=Active%2CActive+-+Client+Unresponsive%2CActive+-+Paused+%28See+Note%29%2CActive+-+Waiting+on+Limits"
      );
    } else {
      const verifier = this.generateCodeVerifier(64);
      const challenge = await this.sha256Base64Url(verifier);
      localStorage.setItem("pkce_code_verifier", verifier);

      const url = new URL(this.AUTH_URL);
      url.searchParams.set("response_type", "code");
      url.searchParams.set("client_id", this.CLIENT_ID);
      url.searchParams.set("redirect_uri", this.REDIRECT_URI);
      url.searchParams.set("scope", "ReadAccounts");
      url.searchParams.set("code_challenge", challenge);
      url.searchParams.set("code_challenge_method", "S256");
      window.location.href = url.toString();
    }
  }

  async exchangeCodeForToken(code) {
    const verifier = localStorage.getItem("pkce_code_verifier");
    const body = new URLSearchParams({
      grant_type: "authorization_code",
      code,
      redirect_uri: this.REDIRECT_URI,
      client_id: this.CLIENT_ID,
      code_verifier: verifier,
    });

    const res = await fetch(this.TOKEN_URL, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body,
    });

    if (!res.ok) {
      throw new Error("Token exchange failed");
    }
    const rcAuth = await res.json();
    await this.setCookie(rcAuth);
    this.RING_CENTRAL_AUTH = rcAuth;
  }

  async setCookie(rcAuth) {
    Cookies.set("ringCentralAuth", JSON.stringify(rcAuth));
  }

  async getCookie() {
    const rcAuth = Cookies.get("ringCentralAuth");
    if (rcAuth) {
      return safeJsonParse(rcAuth);
    }
  }

  async initWebPhone() {
    const auth = await this.getCookie();
    if (!auth) {
      throw new Error("Not authenticated with RingCentral");
    }

    const res = await fetch(
      "https://platform.ringcentral.com/restapi/v1.0/client-info/sip-provision",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${auth.access_token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ sipInfo: [{ transport: "WSS" }] }),
      }
    );

    if (!res.ok) {
      throw new Error("Failed to get SIP info");
    }
    const data = await res.json();

    console.info("SIP Data:", data); // Add debugging to check the data

    const sipInfo = data.sipInfo[0];
    const webPhone = new RingCentralWebPhone({ sipInfo, debug: true });
    // webPhone.on('incomingCall', (call) => {
    //   debugger
    //   console.log('Incoming Call:', call);
    //   call.answer(); // You can handle answering the call here
    // });
    //
    // webPhone.on('callError', (error) => {
    //   debugger
    //   console.log('Call Error:', error);
    //   // This could give you more details about what failed
    // });
    // webPhone.on('callStart', (call) => {
    //   debugger
    //   console.log('Call started:', call);
    // });
    //
    // webPhone.on('callEnd', (call) => {
    //   debugger
    //   console.log('Call ended:', call);
    // });
    //
    // webPhone.on('callError', (error) => {
    //   debugger
    //   console.log('Call Error:', error);
    // });
    // webPhone.on('invite', (session) => {
    //   debugger
    //   session.on('accepted', () => {
    //     debugger
    //   });
    // });

    window.addEventListener("unhandledrejection", (event) => {
      console.error("Unhandled promise rejection:", event.reason);
    });

    window.addEventListener("error", (event) => {
      console.error("Global error:", event.error);
    });

    let callSession;
    await webPhone.start();

    try {
      callSession = await webPhone.call("+12052188243");
    } catch (err) {
      console.error("Failed to initiate call:", err);
      return;
    }

    try {
      callSession.on("progress", () => {
        console.info("Ringing...");
      });

      callSession.on("accepted", () => {
        console.info("Answered.");
      });

      callSession.on("terminated", () => {
        console.info("Terminated.");
      });

      callSession.on("failed", (e) => {
        console.info("Failed:", e);
      });
    } catch (err) {
      console.error("Error registering events:", err);
    }

    // // Initialize the WebPhone instance
    // this.webPhone = new RingCentralWebPhone(data, {
    //   appKey: this.CLIENT_ID,
    //   audioHelper: {
    //     enabled: true,
    //     remote: document.getElementById('remoteAudio')  // Make sure this element exists in the DOM
    //   },
    //   logLevel: 1
    // });
    //
    // // Bind events
    // // this._bindWebPhoneEvents();
    //
    // // Check if the WebPhone is properly initialized
    // if (this.webPhone && this.webPhone.call) {
    //   console.log('WebPhone initialized successfully');
    // } else {
    //   console.error('WebPhone initialization failed');
    // }
  }

  _bindWebPhoneEvents() {
    this.webPhone.userAgent.on("invite", (session) => {
      session.accept(); // auto-answer for demo

      session.on("accepted", () => console.info("Call connected"));
      session.on("terminated", () => console.info("Call ended"));
    });
  }

  async makeCall(_) {
    // if (!this.webPhone) {
    await this.initWebPhone();
    // }
    //     debugger
    //     await this.webPhone.start();
    //     // const webPhone = new WebPhone({ sipInfo, debug: true }); // or pass in other options
    //     const callSession = await this.webPhone.call('16506668888', '16509997777'); // callee, callerId
    //
    //     callSession.on('accepted', () => {
    //       console.log('Call accepted');
    //     });
    //
    //     callSession.on('terminated', () => {
    //       console.log('Call ended');
    //     });
    // debugger
    //     // Ensure the WebPhone instance is properly initialized
    //     if (!this.webPhone || !this.webPhone.call) {
    //       throw new Error('WebPhone not initialized or missing call method');
    //     }
    //
    //     // Assuming you have a valid callerId
    //     const callerId = "16506668888";  // Replace this with a valid caller ID
    //
    //     try {
    //       // Make the outbound call
    //       debugger
    //       const callSession = await this.webPhone.call(to, callerId);
    //
    //       debugger
    //       // Ensure the callSession is not undefined
    //       if (!callSession) {
    //         throw new Error('Failed to get a valid call session');
    //       }
    //
    //       // Handle the call session events
    //       callSession.on('accepted', () => {
    //         console.log('Outgoing call accepted');
    //       });
    //
    //       callSession.on('terminated', () => {
    //         console.log('Call terminated');
    //       });
    //
    //       // If you want to render the remote audio stream
    //       callSession.on('progress', (progress) => {
    //         console.log('Call progress:', progress);
    //       });
    //
    //     } catch (error) {
    //       console.error('Error making call:', error);
    //     }
  }

  async waitForWebPhoneReady(webPhone, timeoutMs = 30000) {
    const sipClient = webPhone._sipClient;

    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      if (
        sipClient &&
        sipClient._userAgent &&
        sipClient._userAgent.isRegistered &&
        sipClient._userAgent.transport &&
        sipClient._userAgent.transport.isConnected
      ) {
        return;
      }
      await new Promise((resolve) => setTimeout(resolve, 100));
    }

    throw new Error("WebPhone did not register in time");
  }
}
